import type { SagaIterator } from 'redux-saga';
import { takeEvery } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import * as actions from './accountsValueChangesActions';
import {
  type AccountsValueChangesPage,
  type AccountsValueChangesPageProps,
  mkAccountsValueChanges,
} from './accountsValueChangesTypes';

type AccountsValueChangesResponse = {
  data?: {
    resources?: AccountsValueChangesPageProps[];
  };
};

const mkAccountsValueChangesResourceConfig =
  resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<AccountsValueChangesPageProps>();

const mkResourceConfig = () =>
  mkAccountsValueChangesResourceConfig({
    resourceName: 'accounts-value-changes',
    resourceBaseUrl: '/reports/accounts/value-changes',
    successAction: actions.getAccountsValueChangesSuccess,
    failureAction: actions.getAccountsValueChangesFailure,
    transformResponseToResources: (response?: AccountsValueChangesResponse | null): AccountsValueChangesPage[] =>
      response?.data?.resources?.map((data) => mkAccountsValueChanges(data)) ?? [],
  });

export function* getAccountsValueChangesActionWatcher(): SagaIterator {
  const resourceConfig = mkResourceConfig();
  // TODO: add reportsSagaUtils and genericSagaUtils
  yield takeEvery(
    actions.getAccountsValueChanges.type,
    resourceSagaUtils.qcsSyncGetResources<AccountsValueChangesPageProps>,
    resourceConfig,
  );
}

export default [getAccountsValueChangesActionWatcher];
